import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { GetCourseTreeObject } from '../../../stores/usercourseTreeobject.store';
import { FilterService } from '../../../services/filter.service';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { EncriptDecriptService } from '../../../services/encriptdecript';

@Component({
  selector: 'app-user-dashboardcards',
  templateUrl: './user-dashboardcards.component.html',
  styleUrls: ['./user-dashboardcards.component.scss'],
  providers: [UserService]
})
export class UserDashboardcardsComponent implements OnInit {
  // video Complete Status
  vdo_val = 100;
  data: any;
  categoriesArr: any[] = [];
  user: any;
  throttle = 300;
  courseName: string;
  direction = '';
  sum = 0;
  sumforInprogress = 0;
  sumforCompleted = 0;
  scrollDistance = 1;
  scrollUpDistance = 2;
  userObj;
  scrollCallback;
  firstTwoCoures: any[] = [];
  inprogresscourseArr: any[] = [];
  complestecourseArr: any[] = [];
  coursebanner;
  status = 'all';
  getcategoryUserlaunchResponse: any = [];
  getParticularCourseObject: any = [];
  NoBookMark = '0';
  BookMarkListObject: any = [];
  recentlyBookmarkBanner: any;
  BookmarkName: any;
  BookMarksize;
  filterText = '';
  public isCourseLoading = true;
  Bannepath: any;
  public isCourseAvailable = true;

  public learnerCourseStatusDataset = new BehaviorSubject([]);
  public userDetails: any;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    public getCourseTreeObject: GetCourseTreeObject,
    private filterService: FilterService,
    private encriptDecript: EncriptDecriptService,

  ) {
    // localStorage.comingFrom = '';
    // localStorage.comingFromObject = '';
    delete localStorage.restart;
    delete localStorage.regiId;
    this.encriptDecript.setToLocalStorage('comingFrom', '');;
    this.encriptDecript.setToLocalStorage('comingFromObject', '');
    this.encriptDecript.setToLocalStorage('coursePageProberty', '');
    this.router.events.subscribe(evt => {
      if (evt instanceof NavigationEnd) {
        this.router.navigated = false;
        window.scrollTo(0, 0);
      }
    });
    // this.scrollCallback = this.getusercourse.bind(this);
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.isCourseLoading = true;
  }

  ngOnInit() {
    this.getCourseTreeObject.categories = [];
    this.userDetails = this.encriptDecript.getLocalStorage('userObject');
    this.userObj = JSON.parse(this.userDetails);
    // this.coursebanner = this.userObj.ftpHost+ this.userObj.ftpRootDir;
    const ftpHost = environment['ftpHost'] + environment['ftpRootDir'];
    this.coursebanner = ftpHost ? ftpHost : environment['cloudPath'];
    this.filterService.filterTerm.subscribe(term => (this.filterText = term));
    this.getLearnerStatusReport(true);

  }

  private getLearnerStatusReport(ApiCall: boolean) {
    this.userService.getLearnerReport(this.userObj).subscribe(
      Response => {
        this.isCourseAvailable = Response.length > 0 ? true : false;
        this.learnerCourseStatusDataset.next(Response);
        this.isCourseLoading = false;
        if (Response.length !== 0) {
          this.categoriesArr = [...Response];
          this.getCourseTreeObject.setEntity(this.categoriesArr);
        }
        if (ApiCall) {
          this.getUserTransactionList();
        }
      },
      (err) => {
        if (ApiCall) {
          this.getUserTransactionList();
        }
      }
    );
  }

  getRecentlyBookMarkedObject(bookmarkAPIcall) {
    const userId = this.userObj.userId;
    const orgId = this.userObj.organisation.organisationId;
    this.userService
      .getRecentlyBookMarkedObject(userId, orgId)
      .subscribe(Response => {
        if (
          Response['BookMark_Size'] === 0 ||
          Response['BookMark_Size'] === '0'
        ) {
          this.BookMarksize = '';
          this.NoBookMark = '0';
        } else {
          this.NoBookMark = '1';
          this.Bannepath = Response['Course_Object'][0].bannerPath;
          this.BookMarksize = Response['BookMark_Size'];
          this.BookMarkListObject = Response['Course_Object'][0];
          this.userObj = this.userObj;
          this.recentlyBookmarkBanner = this.coursebanner + this.Bannepath;
        }
        const testCandiate = this.userObj.isTestCandidateUser;
        if (testCandiate != null && testCandiate == true) {
          this.sendTestCandidateQuizReport();
        }
        // this.getusercourse();
        // if(bookmarkAPIcall){this.getLearnerStatusReport(false);}
      }, error => {
        if (bookmarkAPIcall) { this.getLearnerStatusReport(false); }
      });
  }

  private sendTestCandidateQuizReport() {

    this.userService.sendQuizReport(this.userObj)
      .subscribe(response => {
        console.log(response);
      });

  }

  getAllCourses() {
    this.sum = 0;
    this.categoriesArr = [];
    this.inprogresscourseArr = [];
    this.complestecourseArr = [];
    this.getusercourse();
  }

  getusercourse() {
    return this.userService
      .getusercourse(this.userObj, this.sum, 'all')
      .subscribe(
        Response => {
          this.isCourseLoading = false;
          if (Response.length !== 0) {
            this.categoriesArr = [...Response];
            this.getCourseTreeObject.setEntity(this.categoriesArr);
          }
        },
        error => {
        },
        () => {
          // this.getUserTransactionList();
          // this.getRecentlyBookMarkedObject();
        }
      );
  }
  getUserTransactionList() {
    const organisationId = this.userObj.organisation
      .organisationId;
    const userId = this.userObj.userId;
    return this.userService.getUserTransactionList(organisationId, userId).subscribe(Response => {
      if (Response != null) {
        this.getParticularCourseObject = Response['UserTransaction_Object'];
      } else {
        this.getParticularCourseObject = [];
      }
      this.getRecentlyBookMarkedObject(false);
    }, (error) => {
      this.getRecentlyBookMarkedObject(false);
    });
  }
  getRecentViewList(Objects) {
    // localStorage.comingFrom = 'RecentView';
    // localStorage.comingFromObject = JSON.stringify(Object);
    this.encriptDecript.setToLocalStorage('comingFrom', 'RecentView')
    this.encriptDecript.setToLocalStorage('comingFromObject', Objects.recordId);
    this.router.navigate(['/user/course/browse']);
  }



  getCourses(category) {
    // localStorage.coursePageProberty = '';
    this.encriptDecript.setToLocalStorage('coursePageProberty', '');
    if (category.analytic == null || category.analytic === undefined) {
      this.encriptDecript.setToLocalStorage('coursePageProberty', JSON.stringify({
        queryParams: {
          categoryId: category.categoryId,
          categoryName: category.name,
          bannerPath: category.bannerPath,
          categoryDesc: category.description
        }
      }));
      this.router.navigate(['/user/course/browse'], {
        queryParams: {
          categoryId: category.categoryId,
          categoryName: category.name,
          bannerPath: category.bannerPath,
          categoryDesc: category.description
        }
      });
    } else if (category.fileType === 'video') {
      this.encriptDecript.setToLocalStorage('coursePageProberty', JSON.stringify({
        queryParams: {
          categoryId: category.categoryId,
          categoryName: category.name,
          bannerPath: category.bannerPath,
          categoryDesc: category.description,
          categoryanalytic: category.analytic.lessonVideoProgress
        }
      }));
      this.router.navigate(['/user/course/browse'], {
        queryParams: {
          categoryId: category.categoryId,
          categoryName: category.name,
          bannerPath: category.bannerPath,
          categoryDesc: category.description,
          categoryanalytic: category.analytic.lessonVideoProgress
        }
      });
    } else {
      this.encriptDecript.setToLocalStorage('coursePageProberty', JSON.stringify({
        queryParams: {
          categoryId: category.categoryId,
          categoryName: category.name,
          bannerPath: category.bannerPath,
          categoryDesc: category.description,
          categoryanalytic: category.analytic.lessonCourseProgress
        }
      }));
      this.router.navigate(['/user/course/browse'], {
        queryParams: {
          categoryId: category.categoryId,
          categoryName: category.name,
          bannerPath: category.bannerPath,
          categoryDesc: category.description,
          categoryanalytic: category.analytic.lessonCourseProgress
        }
      });
    }
  }
  SaveBookMark(category: any, value: boolean) {
    var userObj = this.userObj;
    const RequestObject = {
      isBookMarked:
        category.isBookMarked === true || category.isBookMarked === 'true'
          ? false
          : true,
      organisationId: userObj.organisation.organisationId,
      categoryId: category.categoryId,
      userId: userObj.userId
    };
    (category.isBookMarked =
      category.isBookMarked === true || category.isBookMarked === 'true'
        ? false
        : true),
      this.userService.SaveBookMarkServ(RequestObject).subscribe(Response => {
        this.getRecentlyBookMarkedObject(value);
      });
  }
}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/user-module/user-dashboard/user-dashboardcards/user-dashboardcards.component.ts